export default __webpack_public_path__ + "media/zurb/img/services/services/mobile-apps-img-d2bcb5574e8c8f8033753b73d309872b.png";